import {
    CARGAR_CENTROS,
    CARGAR_CENTROS_EXITO,
    CARGAR_CENTROS_ERROR,

    CARGAR_LIQUIDACION_CENTRO,
    CARGAR_LIQUIDACION_CENTRO_EXITO,
    CARGAR_LIQUIDACION_CENTRO_ERROR,

    CARGAR_RESUMEN_CENTROS,
    CARGAR_RESUMEN_CENTROS_EXITO,
    CARGAR_RESUMEN_CENTROS_ERROR,

    CARGAR_ACUERDOS_CENTRO,
    CARGAR_ACUERDOS_CENTRO_EXITO,
    CARGAR_ACUERDOS_CENTRO_ERROR,

    CREAR_ACUERDO_CENTRO,
    CREAR_ACUERDO_CENTRO_EXITO,
    CREAR_ACUERDO_CENTRO_ERROR,

    ACTUALIZAR_ACUERDO_CENTRO,
    ACTUALIZAR_ACUERDO_CENTRO_EXITO,
    ACTUALIZAR_ACUERDO_CENTRO_ERROR,

    CERRAR_ACUERDO_CENTRO,
    CERRAR_ACUERDO_CENTRO_EXITO,
    CERRAR_ACUERDO_CENTRO_ERROR,

    CARGAR_CONFIGURACIONES_CENTRO,
    CARGAR_CONFIGURACIONES_CENTRO_EXITO,
    CARGAR_CONFIGURACIONES_CENTRO_ERROR,

    CREAR_CONFIGURACION_CENTRO,
    CREAR_CONFIGURACION_CENTRO_EXITO,
    CREAR_CONFIGURACION_CENTRO_ERROR,

    CARGAR_POSICION_CENTRO,
    CARGAR_POSICION_CENTRO_EXITO,
    CARGAR_POSICION_CENTRO_ERROR,

    REGISTRAR_PAGO_CENTRO,
    REGISTRAR_PAGO_CENTRO_EXITO,
    REGISTRAR_PAGO_CENTRO_ERROR,

    CARGAR_PAGOS_CENTRO,
    CARGAR_PAGOS_CENTRO_EXITO,
    CARGAR_PAGOS_CENTRO_ERROR,

    ANULAR_PAGO_CENTRO,
    ANULAR_PAGO_CENTRO_EXITO,
    ANULAR_PAGO_CENTRO_ERROR,

    CAMBIAR_PAGAR_PRESTACION_CENTRO,
    CAMBIAR_PAGAR_PRESTACION_CENTRO_EXITO,
    CAMBIAR_PAGAR_PRESTACION_CENTRO_ERROR
} from '../types';


import clienteAxios from '../config/axios';


/*
====================================
NORMALIZAR PACIENTE PARA CACHÉ
====================================
*/

const normalizarPacienteCache = (
    id_paciente
) => {

    if (
        !id_paciente ||
        id_paciente ===
            'TODOS'
    ) {

        return 'TODOS';

    }


    return String(
        id_paciente
    );

};


/*
====================================
CLAVE DEL PERÍODO
====================================
*/

const crearClavePeriodo = ({

    mes = null,

    fecha_desde = null,

    fecha_hasta = null

}) => {

    if (mes) {

        return `MES:${mes}`;

    }


    return [
        'RANGO',
        fecha_desde || '',
        fecha_hasta || ''
    ].join(':');

};


/*
====================================
CLAVE LIQUIDACIÓN INDIVIDUAL
====================================
*/

const crearClaveLiquidacion = ({

    centro_id,

    id_paciente = null,

    mes = null,

    fecha_desde = null,

    fecha_hasta = null,

    moneda = 'ARS'

}) => {

    return [

        `CENTRO:${centro_id}`,

        `PACIENTE:${normalizarPacienteCache(
            id_paciente
        )}`,

        crearClavePeriodo({
            mes,
            fecha_desde,
            fecha_hasta
        }),

        `MONEDA:${moneda}`

    ].join('|');

};


/*
====================================
CLAVE RESUMEN GENERAL
====================================
*/

const crearClaveResumen = ({

    centros,

    id_paciente = null,

    mes = null,

    fecha_desde = null,

    fecha_hasta = null,

    moneda = 'ARS'

}) => {

    const idsCentros =

        Array.isArray(
            centros
        )

            ? centros
                .map(
                    (centro) =>
                        Number(
                            centro.id
                        )
                )
                .filter(
                    (id) =>
                        Number.isFinite(
                            id
                        )
                )
                .sort(
                    (a, b) =>
                        a - b
                )
                .join(',')

            : '';


    return [

        `PACIENTE:${normalizarPacienteCache(
            id_paciente
        )}`,

        crearClavePeriodo({
            mes,
            fecha_desde,
            fecha_hasta
        }),

        `MONEDA:${moneda}`,

        `CENTROS:${idsCentros}`

    ].join('|');

};


/*
====================================
CARGAR CENTROS
====================================

Los centros se consultan una sola vez.

Si ya fueron cargados durante esta
sesión, devolvemos lo que existe
en Redux sin disparar ninguna acción.

forzar=true se utilizará cuando
realmente modifiquemos centros.
====================================
*/

export function cargarCentrosAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const {

            config,

            forzar = false

        } = informacion;


        const estadoCentros =
            getState()
                .centrosLiquidaciones ||
            {};


        /*
        ====================================
        YA ESTÁ EN REDUX
        ====================================
        */

        if (
            !forzar &&
            estadoCentros
                .centrosCargados
        ) {

            return {

                centros:
                    estadoCentros.centros ||
                    []

            };

        }


        /*
        ====================================
        CONSULTAR BACKEND
        ====================================
        */

        dispatch(
            cargarCentros()
        );


        try {

            const {
                data
            } = await clienteAxios.get(

                '/paciente/traercentros',

                config

            );


            dispatch(
                cargarCentrosExito(
                    data
                )
            );


            return data;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudieron cargar los centros';


            dispatch(
                cargarCentrosError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
CARGAR LIQUIDACIÓN INDIVIDUAL
====================================

Busca primero en Redux.

Si la liquidación está cacheada:

1. si ya es la liquidación que estamos
   mostrando, no despacha nada;

2. si estaba cacheada pero estamos
   mostrando otra, solamente cambia
   el dato visible.

No se vuelve a consultar al backend.
====================================
*/

export function cargarLiquidacionCentroAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const {

            config,

            centro_id,

            id_paciente = null,

            mes = null,

            fecha_desde = null,

            fecha_hasta = null,

            moneda = 'ARS',

            incluir_detalle = true,

            forzar = false

        } = informacion;


        const clave =
            crearClaveLiquidacion({

                centro_id,

                id_paciente,

                mes,

                fecha_desde,

                fecha_hasta,

                moneda

            });


        const estadoCentros =
            getState()
                .centrosLiquidaciones ||
            {};


        const liquidacionCache =

            estadoCentros
                .liquidacionesCache
                ?.[clave];


        /*
        ====================================
        EXISTE EN CACHÉ
        ====================================
        */

        if (
            !forzar &&
            liquidacionCache
        ) {


            /*
            ====================================
            YA ES LA ACTUAL
            ====================================

            No hacemos ningún dispatch.

            Esto es importante para evitar
            loops de renderizado.
            ====================================
            */

            if (
                estadoCentros
                    .liquidacionActualKey ===
                clave
            ) {

                return liquidacionCache;

            }


            /*
            ====================================
            ESTABA CACHEADA
            PERO NO ERA LA ACTUAL
            ====================================

            Cambiamos directamente al dato
            guardado.

            No pasamos por CARGAR porque
            no existe ninguna carga real.
            ====================================
            */

            dispatch(
                cargarLiquidacionCentroExito({

                    clave,

                    data:
                        liquidacionCache

                })
            );


            return liquidacionCache;

        }


        /*
        ====================================
        NO EXISTE EN CACHÉ
        ====================================
        */

        dispatch(
            cargarLiquidacionCentro(
                clave
            )
        );


        try {

            const payload = {

                centro_id,

                moneda,

                incluir_detalle

            };


            if (
                id_paciente &&
                id_paciente !==
                    'TODOS'
            ) {

                payload.id_paciente =
                    id_paciente;

            }


            if (mes) {

                payload.mes =
                    mes;

            }


            if (fecha_desde) {

                payload.fecha_desde =
                    fecha_desde;

            }


            if (fecha_hasta) {

                payload.fecha_hasta =
                    fecha_hasta;

            }


            const {
                data
            } = await clienteAxios.post(

                '/paciente/traerliquidacioncentro',

                payload,

                config

            );


            const liquidacion =
                data?.liquidacion ||
                null;


            dispatch(
                cargarLiquidacionCentroExito({

                    clave,

                    data:
                        liquidacion

                })
            );


            return liquidacion;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudo cargar la liquidación del centro';


            dispatch(
                cargarLiquidacionCentroError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
CARGAR RESUMEN DE TODOS LOS CENTROS
====================================

Esta es la consulta principal.

La combinación:

- paciente;
- período;
- moneda;
- centros;

queda guardada en Redux.

Si volvemos a una combinación ya
consultada no volvemos al backend.
====================================
*/

export function cargarResumenCentrosAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const {

            config,

            centros,

            id_paciente = null,

            mes = null,

            fecha_desde = null,

            fecha_hasta = null,

            moneda = 'ARS',

            forzar = false,

            /*
            Se mantiene por compatibilidad
            con llamadas anteriores.

            Con el nuevo resumen masivo,
            si viene informado simplemente
            consideramos que el resumen debe
            refrescarse.
            */
            forzar_centro_id = null

        } = informacion;


        const listaCentros =

            Array.isArray(
                centros
            )

                ? centros

                : [];


        const clave =
            crearClaveResumen({

                centros:
                    listaCentros,

                id_paciente,

                mes,

                fecha_desde,

                fecha_hasta,

                moneda

            });


        const estadoCentros =
            getState()
                .centrosLiquidaciones ||
            {};


        const resumenCache =

            estadoCentros
                .resumenCentrosCache
                ?.[clave];


        /*
        ====================================
        FORZAR
        ====================================

        forzar_centro_id existía cuando
        refrescábamos centro por centro.

        Ahora una actualización del resumen
        siempre es una única request masiva.
        ====================================
        */

        const debeForzar =

            Boolean(
                forzar
            ) ||

            Boolean(
                forzar_centro_id
            );


        /*
        ====================================
        EXISTE EN CACHÉ
        ====================================
        */

        if (
            !debeForzar &&
            Array.isArray(
                resumenCache
            )
        ) {

            /*
            Ya estamos mostrando exactamente
            este resumen.
            */

            if (
                estadoCentros
                    .resumenActualKey ===
                clave
            ) {

                return resumenCache;

            }


            /*
            La combinación estaba cacheada,
            pero actualmente se mostraba otra.
            */

            dispatch(
                cargarResumenCentrosExito({

                    clave,

                    data:
                        resumenCache

                })
            );


            return resumenCache;

        }


        /*
        ====================================
        SIN CENTROS
        ====================================
        */

        if (
            listaCentros.length === 0
        ) {

            dispatch(
                cargarResumenCentrosExito({

                    clave,

                    data:
                        []

                })
            );


            return [];

        }


        /*
        ====================================
        CONSULTAR BACKEND
        ====================================

        UNA sola request para todos los centros.

        No solicitamos detalle de prestaciones.
        El detalle se obtiene aparte solamente
        para el centro seleccionado.
        ====================================
        */

        dispatch(
            cargarResumenCentros(
                clave
            )
        );


        try {

            const payload = {

                resumen_todos_centros:
                    true,

                moneda,

                incluir_detalle:
                    false

            };


            if (
                id_paciente &&
                id_paciente !==
                    'TODOS'
            ) {

                payload.id_paciente =
                    id_paciente;

            }


            if (
                mes
            ) {

                payload.mes =
                    mes;

            }


            if (
                fecha_desde
            ) {

                payload.fecha_desde =
                    fecha_desde;

            }


            if (
                fecha_hasta
            ) {

                payload.fecha_hasta =
                    fecha_hasta;

            }


            const {
                data
            } = await clienteAxios.post(

                '/paciente/traerliquidacioncentro',

                payload,

                config

            );


            const respuestaResumen =
                data?.resumen_centros ||
                {};


            const resumenBackend =

                Array.isArray(
                    respuestaResumen
                        ?.centros
                )

                    ? respuestaResumen
                        .centros

                    : [];


            /*
            ====================================
            MAPA DEL BACKEND
            ====================================
            */

            const mapaResumen =
                new Map();


            resumenBackend.forEach(
                (item) => {

                    mapaResumen.set(

                        String(
                            item.centro_id
                        ),

                        item

                    );

                }
            );


            /*
            ====================================
            MANTENER FORMATO DEL FRONTEND
            ====================================

            El componente ya trabaja con:

            {
                centro,
                liquidacion
            }

            Conservamos ese formato para no
            romper la tabla actual.

            IMPORTANTE:
            esto es solamente un resumen.

            NO se agrega claveLiquidacion.

            De esa manera el reducer NO guarda
            este objeto reducido dentro de la
            caché de liquidaciones detalladas.
            ====================================
            */

            const resultados =
                listaCentros.map(
                    (centro) => {

                        const item =
                            mapaResumen.get(
                                String(
                                    centro.id
                                )
                            );


                        const resumen =

                            item?.resumen ||

                            {
                                prestaciones:
                                    0,

                                cobrado_pacientes_sobre_prestaciones:
                                    '0.00',

                                debitos_generados_periodo:
                                    '0.00',

                                creditos_generados_periodo:
                                    '0.00',

                                deuda_real_pendiente_periodo:
                                    '0.00',

                                deuda_originada_en_cobros_pendiente:
                                    '0.00',

                                estimado_esperando_cobro:
                                    '0.00',

                                pagado_sobre_obligaciones_periodo:
                                    '0.00',

                                creditos_aplicados_periodo:
                                    '0.00'
                            };


                        return {

                            centro,

                            liquidacion: {

                                centro_id:
                                    centro.id,

                                moneda:
                                    respuestaResumen
                                        ?.moneda ||
                                    moneda,

                                periodo:
                                    respuestaResumen
                                        ?.periodo ||
                                    {
                                        mes,
                                        fecha_desde,
                                        fecha_hasta
                                    },

                                resumen,

                                alertas:

                                    item
                                        ?.alertas ||

                                    {
                                        mensuales_cobro_requieren_reprocesamiento:
                                            []
                                    },

                                /*
                                El resumen general jamás
                                contiene detalle.

                                El detalle se consulta
                                solamente para el centro
                                seleccionado.
                                */

                                detalle_prestaciones:
                                    [],

                                detalle_estimados_mensuales_cobro:
                                    [],

                                detalle_mensuales_vinculados:
                                    []

                            }

                        };

                    }
                );


            dispatch(
                cargarResumenCentrosExito({

                    clave,

                    data:
                        resultados

                })
            );


            return resultados;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudo cargar el resumen de centros';


            dispatch(
                cargarResumenCentrosError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
SOLICITAR CENTROS
====================================
*/

const cargarCentros = () => ({

    type:
        CARGAR_CENTROS,

    payload:
        true

});


const cargarCentrosExito = (
    data
) => ({

    type:
        CARGAR_CENTROS_EXITO,

    payload:
        data

});


const cargarCentrosError = (
    msg
) => ({

    type:
        CARGAR_CENTROS_ERROR,

    payload:
        msg

});


/*
====================================
SOLICITAR LIQUIDACIÓN
====================================
*/

const cargarLiquidacionCentro = (
    clave
) => ({

    type:
        CARGAR_LIQUIDACION_CENTRO,

    payload:
        clave

});


const cargarLiquidacionCentroExito = (
    data
) => ({

    type:
        CARGAR_LIQUIDACION_CENTRO_EXITO,

    payload:
        data

});


const cargarLiquidacionCentroError = (
    msg
) => ({

    type:
        CARGAR_LIQUIDACION_CENTRO_ERROR,

    payload:
        msg

});


/*
====================================
SOLICITAR RESUMEN
====================================
*/

const cargarResumenCentros = (
    clave
) => ({

    type:
        CARGAR_RESUMEN_CENTROS,

    payload:
        clave

});


const cargarResumenCentrosExito = (
    data
) => ({

    type:
        CARGAR_RESUMEN_CENTROS_EXITO,

    payload:
        data

});


const cargarResumenCentrosError = (
    msg
) => ({

    type:
        CARGAR_RESUMEN_CENTROS_ERROR,

    payload:
        msg

});

/*
====================================
CREAR CENTRO
====================================

El backend crea en una sola transacción:

- centro;
- primera configuración económica.

Después refrescamos la lista de centros.

Como la clave de caché del resumen
incluye los IDs de todos los centros,
al aparecer un centro nuevo se genera
automáticamente una clave nueva y se
consulta nuevamente solamente lo que
corresponde.
====================================
*/

export function crearCentroAction(
    informacion
) {

    return async (
        dispatch
    ) => {

        try {

            const {

                config,

                datos

            } = informacion;


            const {
                data
            } = await clienteAxios.post(

                '/paciente/crearcentro',

                datos,

                config

            );


            /*
            ====================================
            ACTUALIZAR CENTROS
            ====================================

            Esta consulta sí corresponde hacerla
            porque acabamos de modificar los
            datos reales del sistema.
            ====================================
            */

            await dispatch(
                cargarCentrosAction({

                    config,

                    forzar:
                        true

                })
            );


            return data;


        } catch (error) {

            throw error;

        }

    };

}

/*
====================================
CARGAR ACUERDOS DE UN CENTRO
====================================

Cada centro se consulta una sola vez
durante la sesión.

Incluso una respuesta vacía se considera
cargada y queda guardada en Redux.
====================================
*/

export function cargarAcuerdosCentroAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const {

            config,

            centro_id,

            forzar = false

        } = informacion;


        if (
            !centro_id
        ) {

            return [];

        }


        const claveCentro =
            String(
                centro_id
            );


        const estadoCentros =
            getState()
                .centrosLiquidaciones ||
            {};


        const cache =
            estadoCentros
                .acuerdosCentroCache ||
            {};


        const existeEnCache =
            Object.prototype
                .hasOwnProperty
                .call(
                    cache,
                    claveCentro
                );


        /*
        ====================================
        YA ESTÁ EN CACHÉ
        ====================================
        */

        if (
            !forzar &&
            existeEnCache
        ) {

            const acuerdos =
                Array.isArray(
                    cache[
                        claveCentro
                    ]
                )

                    ? cache[
                        claveCentro
                    ]

                    : [];


            /*
            Ya estamos mostrando ese centro.
            No hacemos ningún dispatch.
            */

            if (
                String(
                    estadoCentros
                        .acuerdosCentroActualId ||
                    ''
                ) ===
                claveCentro
            ) {

                return acuerdos;

            }


            /*
            El centro estaba cacheado,
            pero actualmente mostrábamos otro.
            */

            dispatch(
                cargarAcuerdosCentroExito({

                    centro_id:
                        claveCentro,

                    data:
                        acuerdos

                })
            );


            return acuerdos;

        }


        /*
        ====================================
        CONSULTAR BACKEND
        ====================================
        */

        dispatch(
            cargarAcuerdosCentro(
                claveCentro
            )
        );


        try {

            const {
                data
            } = await clienteAxios.post(

                '/paciente/traeracuerdoscentro',

                {

                    centro_id,

                    incluir_inactivos:
                        false

                },

                config

            );


            const acuerdos =

                Array.isArray(
                    data?.acuerdos
                )

                    ? data.acuerdos

                    : [];


            dispatch(
                cargarAcuerdosCentroExito({

                    centro_id:
                        claveCentro,

                    data:
                        acuerdos

                })
            );


            return acuerdos;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudieron cargar los pacientes vinculados al centro.';


            dispatch(
                cargarAcuerdosCentroError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
CREAR ACUERDO CENTRO - PACIENTE
====================================

Por ahora vinculamos al paciente usando
las condiciones generales del centro.

No enviamos overrides.

Eso permite que el acuerdo herede las
condiciones económicas del centro.
====================================
*/

export function crearAcuerdoCentroAction(
    informacion
) {

    return async (
        dispatch
    ) => {

        dispatch(
            crearAcuerdoCentro()
        );


        try {

            const {

                config,

                datos

            } = informacion;


            const {
                data
            } = await clienteAxios.post(

                '/paciente/crearacuerdocentro',

                datos,

                config

            );


            dispatch(
                crearAcuerdoCentroExito({

                    centro_id:
                        datos.centro_id,

                    acuerdo:
                        data?.acuerdo ||
                        null

                })
            );


            return data;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudo vincular el paciente al centro.';


            dispatch(
                crearAcuerdoCentroError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
SOLICITAR ACUERDOS
====================================
*/

const cargarAcuerdosCentro = (
    centro_id
) => ({

    type:
        CARGAR_ACUERDOS_CENTRO,

    payload:
        centro_id

});


const cargarAcuerdosCentroExito = (
    informacion
) => ({

    type:
        CARGAR_ACUERDOS_CENTRO_EXITO,

    payload:
        informacion

});


const cargarAcuerdosCentroError = (
    error
) => ({

    type:
        CARGAR_ACUERDOS_CENTRO_ERROR,

    payload:
        error

});


/*
====================================
CREAR ACUERDO
====================================
*/

const crearAcuerdoCentro = () => ({

    type:
        CREAR_ACUERDO_CENTRO

});


const crearAcuerdoCentroExito = (
    informacion
) => ({

    type:
        CREAR_ACUERDO_CENTRO_EXITO,

    payload:
        informacion

});


const crearAcuerdoCentroError = (
    error
) => ({

    type:
        CREAR_ACUERDO_CENTRO_ERROR,

    payload:
        error

});

/*
====================================
ACTUALIZAR CONDICIONES DE ACUERDO
====================================

Crea una nueva versión histórica del
acuerdo paciente-centro.

No modifica retrospectivamente las
versiones anteriores.
====================================
*/

export function actualizarAcuerdoCentroAction(
    informacion
) {

    return async (
        dispatch
    ) => {

        dispatch(
            actualizarAcuerdoCentro()
        );


        try {

            const {

                config,

                datos

            } = informacion;


            const {
                data
            } = await clienteAxios.post(

                '/paciente/crearnuevaversionacuerdocentro',

                datos,

                config

            );


            dispatch(
                actualizarAcuerdoCentroExito(
                    data
                )
            );


            return data;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudieron actualizar las condiciones del paciente.';


            dispatch(
                actualizarAcuerdoCentroError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
SOLICITO
====================================
*/

const actualizarAcuerdoCentro = () => ({

    type:
        ACTUALIZAR_ACUERDO_CENTRO

});


/*
====================================
ÉXITO
====================================
*/

const actualizarAcuerdoCentroExito = (
    data
) => ({

    type:
        ACTUALIZAR_ACUERDO_CENTRO_EXITO,

    payload:
        data

});


/*
====================================
ERROR
====================================
*/

const actualizarAcuerdoCentroError = (
    error
) => ({

    type:
        ACTUALIZAR_ACUERDO_CENTRO_ERROR,

    payload:
        error

});

/*
====================================
CERRAR ACUERDO CENTRO - PACIENTE
====================================

Finaliza la vigencia del vínculo.

No elimina el acuerdo.
Se conserva toda la historia anterior.
====================================
*/

export function cerrarAcuerdoCentroAction(
    informacion
) {

    return async (
        dispatch
    ) => {

        dispatch(
            cerrarAcuerdoCentro()
        );


        try {

            const {

                config,

                centro_id,

                acuerdo_id,

                fecha_hasta

            } = informacion;


            const {
                data
            } = await clienteAxios.post(

                '/paciente/cerraracuerdocentro',

                {

                    acuerdo_id,

                    fecha_hasta

                },

                config

            );


            dispatch(
                cerrarAcuerdoCentroExito({

                    centro_id,

                    acuerdo:
                        data?.acuerdo ||
                        null

                })
            );


            return data;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudo finalizar la vinculación del paciente.';


            dispatch(
                cerrarAcuerdoCentroError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
SOLICITO
====================================
*/

const cerrarAcuerdoCentro = () => ({

    type:
        CERRAR_ACUERDO_CENTRO

});


/*
====================================
ÉXITO
====================================
*/

const cerrarAcuerdoCentroExito = (
    informacion
) => ({

    type:
        CERRAR_ACUERDO_CENTRO_EXITO,

    payload:
        informacion

});


/*
====================================
ERROR
====================================
*/

const cerrarAcuerdoCentroError = (
    error
) => ({

    type:
        CERRAR_ACUERDO_CENTRO_ERROR,

    payload:
        error

});

/*
====================================
CARGAR CONFIGURACIONES DEL CENTRO
====================================
*/

export function cargarConfiguracionesCentroAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const {

            config,

            centro_id,

            forzar = false

        } = informacion;


        if (
            !centro_id
        ) {

            return [];

        }


        const claveCentro =
            String(
                centro_id
            );


        const estado =
            getState()
                .centrosLiquidaciones ||
            {};


        const cache =
            estado
                .configuracionesCentroCache ||
            {};


        const existeEnCache =
            Object.prototype
                .hasOwnProperty
                .call(
                    cache,
                    claveCentro
                );


        if (
            !forzar &&
            existeEnCache
        ) {

            const configuraciones =
                Array.isArray(
                    cache[
                        claveCentro
                    ]
                )

                    ? cache[
                        claveCentro
                    ]

                    : [];


            if (
                String(
                    estado
                        .configuracionesCentroActualId ||
                    ''
                ) ===
                claveCentro
            ) {

                return configuraciones;

            }


            dispatch(
                cargarConfiguracionesCentroExito({

                    centro_id:
                        claveCentro,

                    data:
                        configuraciones

                })
            );


            return configuraciones;

        }


        dispatch(
            cargarConfiguracionesCentro(
                claveCentro
            )
        );


        try {

            const {
                data
            } = await clienteAxios.post(

                '/paciente/traerconfiguracionescentro',

                {
                    centro_id
                },

                config

            );


            const configuraciones =
                Array.isArray(
                    data?.configuraciones
                )

                    ? data.configuraciones

                    : [];


            dispatch(
                cargarConfiguracionesCentroExito({

                    centro_id:
                        claveCentro,

                    data:
                        configuraciones

                })
            );


            return configuraciones;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudieron cargar las configuraciones del centro.';


            dispatch(
                cargarConfiguracionesCentroError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
CREAR NUEVA CONFIGURACIÓN
====================================
*/

export function crearConfiguracionCentroAction(
    informacion
) {

    return async (
        dispatch
    ) => {

        dispatch(
            crearConfiguracionCentro()
        );


        try {

            const {

                config,

                datos

            } = informacion;


            const {
                data
            } = await clienteAxios.post(

                '/paciente/crearconfiguracioncentro',

                datos,

                config

            );


            dispatch(
                crearConfiguracionCentroExito(
                    data
                )
            );


            return data;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudo crear la nueva configuración del centro.';


            dispatch(
                crearConfiguracionCentroError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
HELPERS REDUX
====================================
*/

const cargarConfiguracionesCentro = (
    centro_id
) => ({

    type:
        CARGAR_CONFIGURACIONES_CENTRO,

    payload:
        centro_id

});


const cargarConfiguracionesCentroExito = (
    informacion
) => ({

    type:
        CARGAR_CONFIGURACIONES_CENTRO_EXITO,

    payload:
        informacion

});


const cargarConfiguracionesCentroError = (
    error
) => ({

    type:
        CARGAR_CONFIGURACIONES_CENTRO_ERROR,

    payload:
        error

});


const crearConfiguracionCentro = () => ({

    type:
        CREAR_CONFIGURACION_CENTRO

});


const crearConfiguracionCentroExito = (
    data
) => ({

    type:
        CREAR_CONFIGURACION_CENTRO_EXITO,

    payload:
        data

});


const crearConfiguracionCentroError = (
    error
) => ({

    type:
        CREAR_CONFIGURACION_CENTRO_ERROR,

    payload:
        error

});

/*
====================================
CARGAR POSICIÓN DEL CENTRO
====================================

Es la posición económica GLOBAL del
centro.

No depende:
- del período visible;
- del paciente seleccionado.

Se guarda en caché por centro y moneda.
====================================
*/

export function cargarPosicionCentroAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const {

            config,

            centro_id,

            moneda = 'ARS',

            forzar = false

        } = informacion;


        if (
            !centro_id
        ) {

            return null;

        }


        const clave =
            `${String(
                centro_id
            )}|${moneda}`;


        const estado =
            getState()
                .centrosLiquidaciones ||
            {};


        const cache =
            estado
                .posicionCentroCache ||
            {};


        const existeEnCache =
            Object.prototype
                .hasOwnProperty
                .call(
                    cache,
                    clave
                );


        if (
            !forzar &&
            existeEnCache
        ) {

            const posicion =
                cache[
                    clave
                ] ||
                null;


            if (
                estado
                    .posicionCentroActualKey ===
                clave
            ) {

                return posicion;

            }


            dispatch(
                cargarPosicionCentroExito({

                    clave,

                    data:
                        posicion

                })
            );


            return posicion;

        }


        dispatch(
            cargarPosicionCentro(
                clave
            )
        );


        try {

            const {
                data
            } = await clienteAxios.post(

                '/paciente/traerposicioncentro',

                {

                    centro_id,

                    moneda

                },

                config

            );


            const posicion =
                data?.posicion ||
                null;


            dispatch(
                cargarPosicionCentroExito({

                    clave,

                    data:
                        posicion

                })
            );


            return posicion;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudo cargar la posición del centro.';


            dispatch(
                cargarPosicionCentroError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
REGISTRAR PAGO AL CENTRO
====================================
*/

export function registrarPagoCentroAction(
    informacion
) {

    return async (
        dispatch
    ) => {

        dispatch(
            registrarPagoCentro()
        );


        try {

            const {

                config,

                datos

            } = informacion;


            const {
                data
            } = await clienteAxios.post(

                '/paciente/registrarpagocentro',

                datos,

                config

            );


            dispatch(
                registrarPagoCentroExito(
                    data
                )
            );


            return data;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudo registrar el pago al centro.';


            dispatch(
                registrarPagoCentroError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
HELPERS
====================================
*/

const cargarPosicionCentro = (
    clave
) => ({

    type:
        CARGAR_POSICION_CENTRO,

    payload:
        clave

});


const cargarPosicionCentroExito = (
    informacion
) => ({

    type:
        CARGAR_POSICION_CENTRO_EXITO,

    payload:
        informacion

});


const cargarPosicionCentroError = (
    error
) => ({

    type:
        CARGAR_POSICION_CENTRO_ERROR,

    payload:
        error

});


const registrarPagoCentro = () => ({

    type:
        REGISTRAR_PAGO_CENTRO

});


const registrarPagoCentroExito = (
    data
) => ({

    type:
        REGISTRAR_PAGO_CENTRO_EXITO,

    payload:
        data

});


const registrarPagoCentroError = (
    error
) => ({

    type:
        REGISTRAR_PAGO_CENTRO_ERROR,

    payload:
        error

});

/*
====================================
CARGAR HISTORIAL DE PAGOS DEL CENTRO
====================================

Se consulta solamente cuando el usuario
abre el historial.

Después queda cacheado por:
- centro;
- moneda.
====================================
*/

export function cargarPagosCentroAction(
    informacion
) {

    return async (
        dispatch,
        getState
    ) => {

        const {

            config,

            centro_id,

            moneda = 'ARS',

            forzar = false

        } = informacion;


        if (
            !centro_id
        ) {

            return [];

        }


        const clave =
            `${String(
                centro_id
            )}|${moneda}`;


        const estado =
            getState()
                .centrosLiquidaciones ||
            {};


        const cache =
            estado
                .pagosCentroCache ||
            {};


        const existeEnCache =
            Object.prototype
                .hasOwnProperty
                .call(
                    cache,
                    clave
                );


        if (
            !forzar &&
            existeEnCache
        ) {

            const pagos =
                Array.isArray(
                    cache[
                        clave
                    ]
                )

                    ? cache[
                        clave
                    ]

                    : [];


            if (
                estado
                    .pagosCentroActualKey ===
                clave
            ) {

                return pagos;

            }


            dispatch(
                cargarPagosCentroExito({

                    clave,

                    data:
                        pagos

                })
            );


            return pagos;

        }


        dispatch(
            cargarPagosCentro(
                clave
            )
        );


        try {

            const {
                data
            } = await clienteAxios.post(

                '/paciente/traerpagoscentro',

                {

                    centro_id,

                    moneda,

                    incluir_anulados:
                        true

                },

                config

            );


            const pagos =
                Array.isArray(
                    data?.pagos
                )

                    ? data.pagos

                    : [];


            dispatch(
                cargarPagosCentroExito({

                    clave,

                    data:
                        pagos

                })
            );


            return pagos;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudieron cargar los pagos del centro.';


            dispatch(
                cargarPagosCentroError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
ANULAR PAGO DEL CENTRO
====================================
*/

export function anularPagoCentroAction(
    informacion
) {

    return async (
        dispatch
    ) => {

        dispatch(
            anularPagoCentro()
        );


        try {

            const {

                config,

                centro_id,

                moneda = 'ARS',

                pago_centro_id,

                motivo_anulacion

            } = informacion;


            const {
                data
            } = await clienteAxios.post(

                '/paciente/anularpagocentro',

                {

                    pago_centro_id,

                    motivo_anulacion

                },

                config

            );


            dispatch(
                anularPagoCentroExito({

                    clave:
                        `${String(
                            centro_id
                        )}|${moneda}`,

                    pago:
                        data?.pago ||
                        null

                })
            );


            return data;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudo anular el pago del centro.';


            dispatch(
                anularPagoCentroError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
HELPERS HISTORIAL DE PAGOS
====================================
*/

const cargarPagosCentro = (
    clave
) => ({

    type:
        CARGAR_PAGOS_CENTRO,

    payload:
        clave

});


const cargarPagosCentroExito = (
    informacion
) => ({

    type:
        CARGAR_PAGOS_CENTRO_EXITO,

    payload:
        informacion

});


const cargarPagosCentroError = (
    error
) => ({

    type:
        CARGAR_PAGOS_CENTRO_ERROR,

    payload:
        error

});


const anularPagoCentro = () => ({

    type:
        ANULAR_PAGO_CENTRO

});


const anularPagoCentroExito = (
    informacion
) => ({

    type:
        ANULAR_PAGO_CENTRO_EXITO,

    payload:
        informacion

});


const anularPagoCentroError = (
    error
) => ({

    type:
        ANULAR_PAGO_CENTRO_ERROR,

    payload:
        error

});

/*
====================================
CAMBIAR PAGAR / NO PAGAR
PRESTACIÓN DEL CENTRO
====================================
*/

export function cambiarPagarPrestacionCentroAction(
    informacion
) {

    return async (
        dispatch
    ) => {

        dispatch(
            cambiarPagarPrestacionCentro()
        );


        try {

            const {

                config,

                centro_prestacion_id,

                pagar_override,

                observacion = null

            } = informacion;


            const {
                data
            } = await clienteAxios.post(

                '/paciente/cambiarpagarprestacioncentro',

                {

                    centro_prestacion_id,

                    pagar_override,

                    observacion

                },

                config

            );


            dispatch(
                cambiarPagarPrestacionCentroExito(
                    data
                )
            );


            return data;


        } catch (error) {

            const mensajeError =

                error.response?.data ||

                error.message ||

                'No se pudo actualizar la condición de la prestación.';


            dispatch(
                cambiarPagarPrestacionCentroError(
                    mensajeError
                )
            );


            throw error;

        }

    };

}


/*
====================================
HELPERS
====================================
*/

const cambiarPagarPrestacionCentro = () => ({

    type:
        CAMBIAR_PAGAR_PRESTACION_CENTRO

});


const cambiarPagarPrestacionCentroExito = (
    data
) => ({

    type:
        CAMBIAR_PAGAR_PRESTACION_CENTRO_EXITO,

    payload:
        data

});


const cambiarPagarPrestacionCentroError = (
    error
) => ({

    type:
        CAMBIAR_PAGAR_PRESTACION_CENTRO_ERROR,

    payload:
        error

});